import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
  const { colors: color } = useContextState()

  return ({
    headerInputs: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
      alignContent: 'center',
    },
    titleHeaders: {
      lineHeight: '1rem',
      color: color.color9,
      fontSize: '1.4rem',
      marginBottom: '5px',
      fontWeight: '500'
    },
    card: {
      width: '100%',
      overflowX: 'unset',
      minHeight: '300px',
      height: '100%',
      padding: '20px',
      borderRadius: '12px',
      boxShadow: `0 0 4px 0px ${color.color13}`,
      position: 'relative'
    },
    headerTitle: {
      display: 'flex',
      flexDirection: 'column',
    },
    lastUpdate: {
      fontSize: '0.8rem',
      color: color.color10,
    },
    headerActions: {
      display: 'flex',
      gap: '15px',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
    },
    refresh: {
      background: color.orangeMedium,
      color: color.color5,
      borderRadius: '5px',
      '&:hover': {
        background: `${color.orangeMedium}ee`,
      },
      '& .MuiSvgIcon-root': {
        fontSize: '2.2rem',
      }
    },
    })
}

export { useStyles }